import { realBricksApi } from '../../utils/axiosInterceptors';

export const getUserProfileApi = async () => {
  const response = await realBricksApi.get(`/api/v1/user/profile`);
  return response.data;
};
export const updateUserProfile = async (data) => {
  const response = await realBricksApi.put(`/api/v1/user/profile`, data);
  return response.data;
};
export const updateUserAgreements = async (data) => {
  const response = await realBricksApi.put(`/api/v1/user/agreements`, data);
  return response.data;
};
// Completes profile setup for a user who authenticated via Google/Apple (no password —
// they're already authenticated by the provider) instead of creating a brand-new account.
// Explicit Authorization header because this path isn't in TEMP_HEADERS_PATHS and isPinEntered
// is still false at this point, so the request interceptor wouldn't otherwise attach one.
export const submitSocialProfile = async (data) => {
  const accessToken = localStorage.getItem('access_token');
  const response = await realBricksApi.put(`/api/v1/user/social-name`, data, {
    headers: { Authorization: `${accessToken}` },
  });
  return response.data;
};
export const getCountrysApi = async (data) => {
  const response = await realBricksApi.get(`/api/v1/countries?page=${data?.page}&perPage=${data?.perPage}`);
  return response.data;
};
export const getStatesApi = async (data) => {
  const response = await realBricksApi.get(`/api/v1/states?page=${data?.page}&perPage=${data?.perPage}`);
  return response.data;
};
export const getPreSignedUrl = async (fileType, docType, displayView, fileName, platform) => {
  let url = `/api/v1/documents/pre-sign-url/?fileType=${fileType}`;

  if (displayView) {
    url += `&displayView=${displayView}`;
  }

  if (docType) {
    url += `&docType=${docType}`;
  }

  if (platform) {
    url += `&platform=${platform}`;
  }

  if (fileName) {
    url += `&fileName=${fileName}`;
  }

  const response = await realBricksApi.get(url);
  return response.data;
};
// Batched version of getPreSignedUrl for entity documents — requests pre-signed URLs for
// every file in one call instead of one request per document.
export const getEntityDocPreSignedUrls = async (files, platform) => {
  const response = await realBricksApi.post(`/api/v1/documents/pre-sign-urls`, { files }, platform ? { params: { platform } } : undefined);
  return response.data;
};
export const kycAmlVerify = async () => {
  const response = await realBricksApi.get(`/api/v1/user/kyc-aml-verify`);
  return response.data;
};

export const dwollaAgreementsApi = async (data, { rejectWithValue }) => {
  const { onFail = () => {}, onSuccess = () => {} } = data;
  try {
    const response = await realBricksApi.put(`/api/v1/user/dwolla-agreements`);
    onSuccess();
    return response.data;
  } catch (err) {
    onFail();
    return rejectWithValue(err?.response?.data?.message);
  }
};

export const acceptAgreementApi = (policyName, isAccepted) => {
  return realBricksApi.post(
    `/api/v1/legal/accept-agreement`,
    {},
    {
      params: {
        policyName,
        isAccepted,
      },
    }
  );
};
export const uploadVerificationDocApi = async (data) => {
  const response = await realBricksApi.post(`/api/v1/user/upload/verification-doc`, data);
  return response.data;
};

export const acceptSecondaryListingAgreementApi = async () => {
  const response = await realBricksApi.post(`/api/v1/user/accept/secondary-listing-agreement`);
  return response.data;
};

export const getSecondaryMarketAgreementApi = async () => {
  const response = await realBricksApi.get(`/api/v1/properties/secondary-market/agreement`);
  return response.data;
};
